import { useEffect, useState } from 'react';
import axios from 'axios';
import qs from 'qs';
import { useHistory } from 'react-router-dom';
import { rescueHtml } from './Tools';
import { ReactComponent as Switch } from '../Img/icon-switch.svg';

const SwitchOrganisme = (props) =>
{
    let history = useHistory();
    const timestamp = new Date().getTime();
    // const [organismes, setOrganismes] = useState([]);
    const [budgets, setBudgets] = useState([]);
    const [id_budget, setId_budget] = useState('');
    const [id_organisme, setId_organisme] = useState('');
    const [id_organisme_type, setId_organisme_type] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    const green = '#59B44A';

    // Filtrer les organismes en fonction du type sélectionné
    const organismesFiltres = id_organisme_type === '' 
        ? props.organismes 
        : props.organismes.filter(org => org.id_organisme_type == id_organisme_type);

    useEffect(() => {
        if (props.organismes && props.organismes.length > 0) {
            setIsLoading(false);
        }
    }, [props.organismes])


    function switch_organisme()
    {
        if (id_budget != '' && id_organisme != '')
        {
            const params = {
                'id': props.user.id,
                'id_budget': id_budget,
                'id_organisme': id_organisme,
                'updateUser': true
            };
            axios.post('https://app-slfinance.fr/api/connexion.php', qs.stringify(params))
            .then(async () => {
                await props.getUser()
                await new Promise(resolve => setTimeout(resolve, 700));
                await history.push('/organismepage?timestamp=' + timestamp)
            })
            .catch((err) => {
                console.warn(err)
            })
        }
    }

	return (
        <div className='shadow-xl' style={{textAlign: 'center',  borderRadius: 3, padding: 5, margin: 1, backgroundColor: 'white'}}>
            <p>Switch Organisme :</p>
            {isLoading ? (
                <div style={{margin: 10, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 100}}>
                    <div className='spinner' style={{
                        border: '4px solid #f3f3f3',
                        borderTop: '4px solid #6571FE',
                        borderRadius: '50%',
                        width: '40px',
                        height: '40px',
                        animation: 'spin 1s linear infinite'
                    }}>
                        <style>{`
                            @keyframes spin {
                                0% { transform: rotate(0deg); }
                                100% { transform: rotate(360deg); }
                            }
                        `}</style>
                    </div>
                </div>
            ) : (
            <div style={{margin: 10, textAlign: 'center'}}>
                <div style={{marginBottom: 15}}>
                    <label style={{display: 'block', marginBottom: 5, fontWeight: 'bold'}}>Type d'organisme :</label>
                    <select
                        style={{padding: 5}}
                        className='shadow-md'
                        value={id_organisme_type}
                        onChange={(e) => {
                            setId_organisme_type(e.target.value);
                            setId_organisme('');
                            setId_budget('');
                            setBudgets([]);
                        }}
                    >
                        <option value="">Tous les types</option>
                        <option value="1">COMMUNE</option>
                        <option value="2">EPCI</option>
                        <option value="3">SYNDICAT</option>
                        <option value="4">EPFL</option>
                    </select>
                </div>

                <div>
                    <label style={{display: 'block', marginBottom: 5, fontWeight: 'bold'}}>Organisme :</label>
                    <select
                    style={{padding: 5}}
                        className='shadow-md'
                        value={id_organisme}
                        onChange={async e => {
                            await setId_organisme(e.target.value)
                            await axios.get("https://app-slfinance.fr/api/budgets.php?id_organisme="+e.target.value+'&list=true')
                            .then(async (result) => {
                                var tmp = []
                                var i = 0
                                await result.data.forEach(async budget => {
                                    if (budget.budget_annexe === '0') {
                                        tmp[i] = {
                                            'id_budget': budget.id,
                                            'budget_annexe': budget.budget_annexe,
                                            'nom': budget.nom,
                                            'siret': budget.siret
                                        }
                                        i++;
                                    }
                                });
                                
                                await result.data.forEach(async budget => {
                                    if(budget.budget_annexe === '1') {
                                        tmp[i] = {
                                            'id_budget': budget.id,
                                            'budget_annexe': budget.budget_annexe,
                                            'nom': budget.nom,
                                            'siret': budget.siret
                                        }
                                        i++;
                                    }
                                });
                                await setId_budget(tmp[0].id_budget)
                                await setBudgets(tmp);
                            })
                            .catch((err) => {
                                console.warn(err)
                            })
                        }}
                    >
                        <option value="">...</option>
                        {
                            organismesFiltres.map((organisme) => 
                            <option key={organisme['id']} value={organisme['id']} >{rescueHtml(organisme['nom'])}</option>
                            )
                        }
                    </select>
                </div>



                        
                {id_organisme != '' && budgets.length != 0 &&
                <label style={{marginTop: 10, display: 'block', marginBottom: 5, fontWeight: 'bold'}}>Budgets :</label>
                }
                {id_organisme != '' && budgets.length != 0?
                <div style={{textAlign: 'center'}}>
                    <div>
                        <select
                        className='shadow-md'
                        value={id_budget}
                        onChange={async (e) => {
                            await setId_budget(e.target.value)
                        }}>
                            {budgets.map((elem, i) => 
                            <option key={i} value={elem.id_budget}>{rescueHtml(elem.nom)}</option>
                            )}
                        </select>
                    </div>

                    <div style={{display: 'flex'}}>
                        <div style={{flex: 1}}></div>
                        <button
                        style={{marginTop: 10, display: 'flex', color: 'white', backgroundColor: green, borderRadius: 5, alignItems: 'center', justifyContent: 'center'}}
                        onClick={() => {switch_organisme()}}
                        >
                            <div style={{alignItems: 'center', justifyContent: 'center', display: 'flex', paddingLeft: 10, paddingRight: 10}}>
                                <Switch width="12" />
                                <p style={{marginLeft: 5}}>Go !</p>
                            </div>
                        </button>
                        <div style={{flex: 1}}></div>
                    </div>

                </div>
                :null}
            </div>
            )}
        </div>
	);
}

export default SwitchOrganisme;
